import { useModelState } from "@/utils/useModelState";
import { BookingPeriodConditionTypes } from "./BookingPeriodConditionTypes/BookingPeriodConditionType";

export function YearlyDateBookingPeriodConditionTypeComponent({ conditionType }: YearlyDateBookingPeriodConditionTypeComponentProps) {

    const [operator, setOperator] = useModelState(conditionType.operator);
    const [month, setMonth] = useModelState(conditionType.month);
    const [day, setDay] = useModelState(conditionType.day);

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const getDaysInMonth = (monthValue: number): number => {
        const daysInMonth = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        return daysInMonth[monthValue - 1] || 31;
    };

    const handleMonthChange = (newMonth: number) => {
        setMonth(newMonth);

        // Adjust day if it's invalid for the new month
        const maxDaysInMonth = getDaysInMonth(newMonth);
        if (day > maxDaysInMonth) {
            setDay(maxDaysInMonth);
        }
    };

    const handleDayChange = (newDay: number) => {
        const maxDaysInMonth = getDaysInMonth(month);
        if (newDay >= 1 && newDay <= maxDaysInMonth) {
            setDay(newDay);
        }
    };

    const maxDaysInMonth = getDaysInMonth(month);

    return (
        <div className="flex flex-row gap-2">
            <div>
                <select className="form-control" value={operator} onChange={e => setOperator(e.target.value as BookingPeriodConditionTypes.YearlyDateComparisonOperator)}>
                    <option value="gt">&gt;</option>
                    <option value="gte">&gt;=</option>
                    <option value="lt">&lt;</option>
                    <option value="lte">&lt;=</option>
                    <option value="eq">=</option>
                    <option value="neq">!=</option>
                </select>
            </div>
            <div>
                <select className="form-control" value={month} onChange={e => handleMonthChange(parseInt(e.target.value))}>
                    {monthNames.map((monthName, index) => (
                        <option key={index + 1} value={index + 1}>
                            {monthName}
                        </option>
                    ))}
                </select>
            </div>
            <div>
                <input
                    className="form-control"
                    type="number"
                    min="1"
                    max={maxDaysInMonth}
                    value={day}
                    onChange={e => handleDayChange(parseInt(e.target.value))}
                    style={{ width: '80px' }}
                />
            </div>
        </div>
    );
}

export interface YearlyDateBookingPeriodConditionTypeComponentProps {
    conditionType: BookingPeriodConditionTypes.YearlyDateBookingPeriodConditionType;
}
